import React, { useState, useEffect } from 'react';
import Remove from '../../assets/remove.png';
import PerfectScrollbar from 'react-perfect-scrollbar';

const Users = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [profile, setProfile] = useState('');
  const [adresse, setAdresse] = useState('');
  const [contact, setContact] = useState('');
  const [password, setPassword] = useState('');
  const [users, setUsers] = useState([]);

  const registerUsers = async (event) => {
    event.preventDefault();
    try {
      const response = await fetch('https://fusionsmart.seifeddineslimene.com/api/users', {
        method: 'POST',
        headers: {
          'Content-type': 'application/json',
        },
        body: JSON.stringify({
          name,
          email,
          profile,
          adresse,
          contact,
          password,
        }),
      });
      const data = await response.json();
      const { lastAddedUser } = data;
      setUsers([...users, lastAddedUser]);
      setName('');
      setEmail('');
      setProfile('');
      setAdresse('');
      setContact('');
      setPassword('');
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetch('https://fusionsmart.seifeddineslimene.com/api/users', {
      method: 'GET', // Spécifie la méthode GET
      headers: {},
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setUsers(data);
      })
      .catch((error) => console.error('Error fetching users:', error));
  }, []);

  const deleteUser = (id) => {
    fetch(`https://fusionsmart.seifeddineslimene.com/api/users/${id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Error deleting user');
        }
        return response.json();
      })
      .then(() => {
        setUsers(users.filter((user) => user._id !== id));
        alert('User deleted successfully');
      })
      .catch((error) => {
        console.error('Error deleteClick', error);
      });
  };

  return (
    <div
      id='content-body'
      className='d-flex flex-column align-items-center col-12 col-md-9 col-xl-10 pl-4 pr-4 bd-content overflow-auto'
    >
      <div className='mb-8' style={{ height: '60px' }}>
        <div className='col-md-12 pt-4'>
          <h2>Users Management</h2>
        </div>
      </div>
      <div
        className='text-center mt-5'
        style={{
          height: 'calc(100vh - 150px - 60px)',
          boxSizing: 'border-box',
          overflow: 'auto',
        }}
      >
        <PerfectScrollbar>
          <form
            onSubmit={registerUsers}
            className='user ms-2 mb-5 row'
            style={{ width: '90%' }}
          >
            <div className='col-6 d-flex justify-content-center align-items-center mb-4'>
              <span className='d-inline-block me-2'>Nom</span>
              <input
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder=' Name'
                type='text'
                className='w-75 px-4 py-4 border rounded-lg'
              />
            </div>
            <div className='col-6 d-flex justify-content-center align-items-center mb-4'>
              <span className='d-inline-block me-2'>Email</span>
              <input
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder='Email'
                type='email'
                className='w-75 px-4 py-4 border rounded-lg'
              />
            </div>
            <div className='col-6 d-flex justify-content-center align-items-center mb-4'>
              <span className='d-inline-block me-2'>Profile</span>
              <input
                value={profile}
                onChange={(e) => setProfile(e.target.value)}
                placeholder='Profile'
                type='text'
                className='w-75 px-4 py-4 border rounded-lg'
              />
            </div>
            <div className='col-6 d-flex justify-content-center align-items-center mb-4'>
              <span className='d-inline-block me-2'>Adresse</span>
              <input
                value={adresse}
                onChange={(e) => setAdresse(e.target.value)}
                placeholder='Adresse'
                type='text'
                className='w-75 px-4 py-4 border rounded-lg'
              />
            </div>
            <div className='col-6 d-flex justify-content-center align-items-center mb-4'>
              <span className='d-inline-block me-2'>Contact</span>
              <input
                value={contact}
                onChange={(e) => setContact(e.target.value)}
                placeholder='Contact'
                type='text'
                className='w-75 px-4 py-4 border rounded-lg'
              />
            </div>
            <div className='col-6 d-flex justify-content-center align-items-center mb-4'>
              <span className='d-inline-block me-2'>Password</span>
              <input
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder='Password'
                type='password'
                className='w-75 px-4 py-4 border rounded-lg'
              />
            </div>
            <div className='col-12'>
              <button
                type='submit'
                className='bg-primary text-white py-2 px-4 rounded border border-0 fw-bold ms-5'
              >
                Envoyer
              </button>
            </div>
          </form>
          <table className='table'>
            <thead>
              <tr className='bg-black text-white text-left'>
                <th className='px-4 py-6 font-bold'>nom</th>
                <th className='px-4 py-6'>profile</th>
                <th className='px-4 py-6'>adresse</th>
                <th className='px-4 py-6'>contact</th>
                <th className='px-4 py-6'>email</th>
                <th className='px-4 py-6'>Actions</th>
              </tr>
            </thead>
            <tbody>
              {users &&
                users.map((val) => (
                  <tr key={val._id}>
                    <td>{val.profile}</td>
                    <td>{val.name}</td>
                    <td>{val.adresse}</td>
                    <td>{val.contact}</td>
                    <td>{val.email}</td>
                    <td className='shadow-sm px-4 py-6'>
                      <div className='flex flex-row justify-between gap-4 cursor-pointer w-4 h-4 '>
                        <img
                          style={{ cursor: 'pointer' }}
                          src={Remove}
                          alt='remove'
                          onClick={() => {
                            deleteUser(val._id);
                          }}
                        />
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </PerfectScrollbar>
      </div>
      <div className='row position-absolute bottom-0 start-25 w-75'>
        <div className='col-md-12 py-3'>
          <span className='footer-text-1'>Energy Tip: </span>
          <span className='footer-text-2'>
            On all days, turning off or unplugging electrical devices when
            you're not at departments can help reduce your energy costs by
            approximately 10 percent.
          </span>
        </div>
      </div>
    </div>
  );
};

export default Users;


